var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastBoardColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 56,
    viewBox: "0 0 72 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.78 26.3938C69.2211 23.5714 71.2044 19.681 71.2044 15.7143C71.2044 14.1123 70.9756 12.5104 70.5179 10.9847C69.6025 7.47571 67.4666 4.65325 64.4152 2.6699C61.7453 0.915393 58.4652 0 54.651 0H34.8938L33.2919 7.62828H54.5748C56.8632 7.62828 58.694 8.08598 59.9908 9.00137L60.1434 9.15393C61.5928 10.0693 62.5845 11.3661 63.0421 13.0444L63.1184 13.2732C63.3473 14.1123 63.4998 14.9514 63.4998 15.7905C63.4998 18.2316 61.2876 21.588 59.1517 23.19L55.4902 25.9361L58.9229 29.0637C59.6857 29.7503 60.3722 30.5894 60.8299 31.4285L60.9062 31.5048C61.8979 33.183 62.4319 35.1664 62.4319 37.0734C62.4319 43.0998 57.4735 48.0582 51.4472 48.0582C51.0658 48.0582 49.9978 48.0582 48.9298 48.0582C47.7093 48.0582 46.5651 48.0582 46.1074 48.0582H24.8245L23.2225 55.6864H46.1074C46.5651 55.6864 47.7093 55.6864 48.9298 55.6864C50.0741 55.6864 51.142 55.6864 51.5234 55.6864C61.7453 55.6864 70.1365 47.3716 70.1365 37.0734C70.1365 33.7933 69.2211 30.5131 67.5428 27.6144C67.2377 27.1567 67.0089 26.7753 66.78 26.3938Z",
    fill: "url(#paint0_linear_2908_18753)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1561 40.4287H26.9606C23.9092 40.4287 21.1631 38.2165 20.5528 35.2414L19.79 31.8087H29.3253L27.7234 24.1804H17.4252C14.3739 24.1804 11.6277 21.9682 11.0175 18.9932L10.2546 15.2553H32.0715C35.1228 15.2553 37.869 17.4675 38.4793 20.4426L39.2421 24.0279H47.0229L45.955 18.8406C44.5819 12.2803 38.7844 7.55078 32.0715 7.55078H0.795563L3.54174 20.5189C4.53342 25.0958 7.66101 28.7574 11.704 30.5119L13.0771 36.7671C14.4502 43.3274 20.2477 48.0569 26.8843 48.0569H32.6818L31.1561 40.4287Z",
    fill: "url(#paint1_linear_2908_18753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2908_18753",
    x1: 64.8378,
    y1: 49.9501,
    x2: 24.909,
    y2: 10.0213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2908_18753",
    x1: 41.2304,
    y1: 39.5249,
    x2: 5.02864,
    y2: 3.32319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastBoardColor);
export default __webpack_public_path__ + "static/media/fastBoardColor.f8919db9b4ed0dc717d21ad69dc32e90.svg";
export { ForwardRef as ReactComponent };